(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {

  constructor() {

    super();

    this.setHeaderHeight =
      this.setHeaderHeight.bind(this);

    this.onScroll =
      this.onScroll.bind(this);

  }


  connectedCallback() {

    this.header =
      document.querySelector('.section-header');

    if (!this.header) {
      return;
    }


    this.mobileMediaQuery =
      window.matchMedia('(max-width: 990px)');


    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';


    this.currentScrollTop = 0;

    this.preventReveal = false;

    this.headerBounds = {};


    this.setHeaderHeight();


    this.mobileMediaQuery.addEventListener(
      'change',
      this.setHeaderHeight
    );


    if (this.headerIsAlwaysSticky) {

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

    }


    this.predictiveSearches =
      this.querySelectorAll('predictive-search');


    this.onScrollHandler =
      this.onScroll.bind(this);


    this.addEventListener(
      'preventHeaderReveal',
      () => {
        this.preventReveal = true;
      }
    );


    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      false
    );


    this.createObserver();

  }


  setHeaderHeight() {

    if (!this.header) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );

  }


  disconnectedCallback() {

    this.mobileMediaQuery.removeEventListener(
      'change',
      this.setHeaderHeight
    );

    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

  }


  createObserver() {

    const observer =
      new IntersectionObserver(
        (entries, observer) => {

          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();

        }
      );


    observer.observe(this.header);

  }


  onScroll() {

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;


    if (
      [...this.predictiveSearches].some(
        (predictiveSearch) =>
          predictiveSearch.isOpen
      )
    ) {
      return;
    }


    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {

      this.header.classList.add(
        'scrolled-past-header'
      );


      if (this.preventReveal) {
        return;
      }


      requestAnimationFrame(
        () => this.hide()
      );

    }

    else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {

      this.header.classList.add(
        'scrolled-past-header'
      );


      if (!this.preventReveal) {

        requestAnimationFrame(
          () => this.reveal()
        );

      }

    }

    else if (
      scrollTop <= this.headerBounds.top
    ) {

      this.header.classList.remove(
        'scrolled-past-header'
      );


      requestAnimationFrame(
        () => this.reset()
      );

    }


    this.currentScrollTop =
      scrollTop;

  }


  hide() {

    if (this.headerIsAlwaysSticky) {
      return;
    }


    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

  }


  reveal() {

    if (this.headerIsAlwaysSticky) {
      return;
    }


    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );


    this.header.classList.remove(
      'shopify-section-header-hidden'
    );

  }


  reset() {

    if (this.headerIsAlwaysSticky) {
      return;
    }


    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );

  }

}


if (!customElements.get('sticky-header')) {

  customElements.define(
    'sticky-header',
    StickyHeader
  );

}


  } catch(e) { console.error(e); }
})();
})();
